import { MARKETING_PLUS_SUITE } from 'self-service-api/constants/BundleTypes';
import { getMerchCardsToShowForBundle } from '../../constants/merchCards/MerchCardsToShow';
import { useAppSelector } from '../../reducers';
import { SSM0004ExperimentSelector } from '../../utils/experiments/ssm0004';
import BundleTile from '../merch-card/BundleTile';
import BundleTiles from '../merch-card/BundleTiles';
import SSM0004BundleTile from '../merch-card/SSM0004BundleTile';
import { jsx as _jsx } from "react/jsx-runtime";
export const MarketingPlusTiles = ({
  screen
}) => {
  const productLevelsToShow = getMerchCardsToShowForBundle({
    bundleType: MARKETING_PLUS_SUITE
  });
  const {
    isSSM0004Variant
  } = useAppSelector(SSM0004ExperimentSelector);
  return /*#__PURE__*/_jsx(BundleTiles, {
    columns: productLevelsToShow.length,
    children: productLevelsToShow.map((productLevel, index) => {
      const commonStyles = {
        msGridColumn: index + 1,
        // IE
        gridColumnStart: index + 1,
        paddingLeft: 28,
        paddingRight: 28
      };
      if (isSSM0004Variant) {
        return /*#__PURE__*/_jsx(SSM0004BundleTile, {
          bundleType: MARKETING_PLUS_SUITE,
          productLevel: productLevel,
          commonStyles: commonStyles,
          screen: screen
        }, `${MARKETING_PLUS_SUITE}-${productLevel}`);
      }
      return /*#__PURE__*/_jsx(BundleTile, {
        bundleType: MARKETING_PLUS_SUITE,
        productLevel: productLevel,
        commonStyles: commonStyles,
        screen: screen
      }, `${MARKETING_PLUS_SUITE}-${productLevel}`);
    })
  });
};
export default MarketingPlusTiles;